// removed by extract-text-webpack-plugin
module.exports = {"videoContainer":"VideoPlayer__videoContainer___3rHjj","closeButton":"VideoPlayer__closeButton___2rV6Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoPlayer/VideoPlayer.scss
// module id = 1551
// module chunks = 0